import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const ChevronDown16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M12.7461 7.51667L12.7451 7.51772L8.57068 11.7296C8.41147 11.9189 8.20279 12 8.00036 12C7.79783 12 7.59286 11.9195 7.43474 11.7591L3.25531 7.51737C2.92808 7.18233 2.9133 6.6286 3.22314 6.27771C3.53617 5.92147 4.05942 5.91084 4.3867 6.24452L8.00031 9.91161L11.6139 6.2417C11.9419 5.90758 12.4633 5.9208 12.7773 6.27556C13.0856 6.62789 13.0725 7.18139 12.7461 7.51667Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
